import { useMediaQuery } from 'react-responsive';
import {
	NotificationOptions,
	showErrorNotification,
	showInfoNotification,
	showSuccessNotification,
	showWarningNotification,
} from '@/lib/notifications/notification-center';

type ToastStatus = 'success' | 'error' | 'warning' | 'info';

interface CustomToastOptions {
	title?: string;
	description?: string;
	status: ToastStatus;
	duration?: number;
	illustration?: string;
	accentColor?: string;
}

export const useCustomToast = () => {
	const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' });

	const showCustomToast = (options: CustomToastOptions) => {
		const { title, description, status, duration = 5000, illustration, accentColor } = options;

		const position: NotificationOptions['position'] = isDesktopOrLaptop ? 'top-right' : 'top-center';
		const base: Omit<NotificationOptions, 'intent'> = {
			title,
			description,
			duration,
			position,
			illustration,
			accentColor,
		};

		switch (status) {
			case 'success':
				showSuccessNotification(base);
				break;
			case 'error':
				showErrorNotification(base);
				break;
			case 'warning':
				showWarningNotification(base);
				break;
			default:
				showInfoNotification(base);
		}
	};

	return showCustomToast;
};
